import { render, staticRenderFns } from "./Collection.vue?vue&type=template&id=af316bf6&"
import script from "./Collection.vue?vue&type=script&lang=js&"
export * from "./Collection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports